import * as client from '../../services/client';
import { TYPES } from 'src/common/constants';
import { PATHS } from 'src/common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  startLoading,
  stopLoading,
  startFormLoading,
  stopFormLoading,
} from './loader';
import {
  fetchPropertyById,
} from './properties';

const fetchContactsDone = (payload) => ({
  type: TYPES.FETCH_CONTACTS_DONE,
  payload,
});

export const fetchContacts = (id, role) => (dispatch) => {
  dispatch(startLoading());
  return client
  .getContacts()
  .then((response) => {
    dispatch(stopLoading());
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(fetchContactsDone(responsejson));
        dispatch(stopLoading());
      });
    } else {
      dispatch(stopLoading());
    }
  })
  .catch(() => {
    dispatch(stopLoading());
  });
};

const deleteContactDone = (payload) => ({
  type: TYPES.DELETE_CONTACT_DONE,
  payload,
});

export const deleteContactById =
  (contactId, history, propertyId) => (dispatch) => {
    dispatch(startFormLoading());

    return client.deleteContactById(contactId).then((response) => {
      dispatch(stopFormLoading());

      if (response.ok || response.status === 200) {
        dispatch(deleteContactDone(contactId));

        if (history && history !== 'FromPropertyDeveloper') {
          history.push(PATHS.CONTACTS_LIST);
        } else {
          dispatch(fetchPropertyById(propertyId));
        }
        toast.success(' ⓘ The user has been deleted.', {
          autoClose: 10000,
          position: 'top-center',
        });
      } else {
        toast.error(
          '🚫 Something went wrong with deleting a contact, please try again.',
          {
            autoClose: 12000,
            position: 'top-center',
          },
        );
      }
    });
  };

export const sendInvitationToContact = (params) => (dispatch) => {
  dispatch(startFormLoading());
  return client
  .sendInvitationToContact(params)
  .then((response) => {
    dispatch(stopFormLoading());

    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {
        toast.success('Selected users will receive invitations shortly.', {
          autoClose: 10000,
          position: 'top-center',
        });
      });
    } else {
      toast.error(
        '🚫 Something went wrong with sending activation links to users, please try again.',
        {
          autoClose: 12000,
          position: 'top-center',
        },
      );
    }
  })
  .catch(() => {
    dispatch(stopFormLoading());
    toast.error(
      '🚫 Something went wrong with sending activation links to users, please try again.',
      {
        autoClose: 12000,
        position: 'top-center',
      },
    );
  });
};

export const onEventScheduled = (params) => (dispatch) => {
  return client.onEventScheduled(params).then((response) => {
    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {
        toast.success('Event Scheduled successfully.', {
          autoClose: 10000,
          position: 'top-center',
        });
      });
    }
  });
};

export const fetchServiceProviders = (issueType) => (dispatch) => {
  dispatch(startFormLoading());
  return client
  .getServiceProviders(issueType)
  .then((response) => {
    dispatch(stopFormLoading());
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(fetchSuiteUsersDone(responsejson));
      });
    } else {
      dispatch(stopFormLoading());
      dispatch(fetchSuiteUsersDone([]));
    }
  })
  .catch(() => {
    dispatch(stopFormLoading());
    dispatch(fetchSuiteUsersDone([]));
  });
};

const fetchSuiteUsersDone = (payload) => ({
  type: TYPES.FETCH_SUITE_USERS_LIST,
  payload,
});
